const API_URL = process.env.REACT_APP_API_URL || 'https://your-api-gateway-url';

export const api = {
  async getStats(period = 'today', country) {
    let url = `${API_URL}/stats?period=${period}`;
    if (country) {
      url += `&country=${country}`;
    }
    const response = await fetch(url);
    return response.json();
  },

  async getContracts(country, limit = 1000) {
    let allItems = [];
    let lastKey = null;
    
    do {
      let url = lastKey 
        ? `${API_URL}/contracts?limit=${limit}&lastKey=${lastKey}`
        : `${API_URL}/contracts?limit=${limit}`;
      
      if (country) {
        url += `&country=${country}`;
      }

      const response = await fetch(url);
      const data = await response.json();
      
      allItems = allItems.concat(data.items);
      lastKey = data.lastKey;
    } while (lastKey);
    
    return { items: allItems };
  },

  async subscribe(data) {
    const response = await fetch(`${API_URL}/subscribe`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    });
    return response.json();
  },

  async updatePreferences(data) {
    const response = await fetch(`${API_URL}/preferences`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    });
    return response.json();
  },

  async getSubscriptions() {
    const response = await fetch(`${API_URL}/subscriptions`);
    return response.json();
  },

  async deleteSubscription(userId, deviceId) {
    const response = await fetch(`${API_URL}/subscriptions`, {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ userId, deviceId })
    });
    return response.json();
  },

  async getOperational(country, group) {
    let url = `${API_URL}/operational`;
    const params = [];
    if (country) params.push(`country=${country}`);
    if (group) params.push(`group=${group}`);
    if (params.length) url += '?' + params.join('&');
    const response = await fetch(url);
    return response.json();
  },

  async getOperationalStats(country, period = 'today') {
    let url = `${API_URL}/operational/stats?period=${period}`;
    if (country) url += `&country=${country}`;
    const response = await fetch(url);
    return response.json();
  },

  async getRebelnetContracts(limit = 1000) {
    let allItems = [];
    let lastKey = null;
    
    do {
      const url = lastKey 
        ? `${API_URL}/rebelnet?limit=${limit}&lastKey=${lastKey}`
        : `${API_URL}/rebelnet?limit=${limit}`;
      
      const response = await fetch(url);
      const data = await response.json();
      
      allItems = allItems.concat(data.items);
      lastKey = data.lastKey;
    } while (lastKey);
    
    return { items: allItems };
  },

  async authenticate(data) {
    const response = await fetch(`${API_URL}/auth`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    });
    return response.json();
  },

  async getRebelnetConfig() {
    const response = await fetch(`${API_URL}/rebelnet/config`);
    return response.json();
  },

  async saveRebelnetConfig(data) {
    const response = await fetch(`${API_URL}/rebelnet/config`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    });
    return response.json();
  }
};
